import { useContext, createContext } from 'react';
export var WidgetEnvironmentContext = createContext(null);
export var WidgetEnvironmentProvider = WidgetEnvironmentContext.Provider;
export var WidgetEnvironmentConsumer = WidgetEnvironmentContext.Consumer;
export var SettingsEnvironmentContext = createContext(null);
export var SettingsEnvironmentProvider = SettingsEnvironmentContext.Provider;
export var SettingsEnvironmentConsumer = SettingsEnvironmentContext.Consumer;
export var useEnvironment = function () {
    var context = useContext(WidgetEnvironmentContext);
    if (!context) {
        throw new Error("`useEnvironment()` can't be used within a `Settings` component. Please use `useSettingsEnvironment()`");
    }
    return context;
};
export var useSettingsEnvironment = function () {
    var context = useContext(SettingsEnvironmentContext);
    if (!context) {
        throw new Error("`useSettingsEnvironment()` can't be used within a `Widget` component. Please use `useEnvironment()`");
    }
    return context;
};
//# sourceMappingURL=EnvironmentProvider.js.map